<div class="px-3">


  <div class="rem-text-default mb-6">
    <div class="flex align-items-center">
      <icon-button
        *ngIf="isOffersTypeView"
        pTooltip='Back'
        tooltipPosition='left'
        (click)="onCloseOfferTypeView()"
        [icon]="'chevron-left'"
        class="pr-2"
      />
      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-users font-medium text-xl"></i>
      </div>
      @if(!isOffersTypeView){
        <div>
          <div class="text-2xl font-medium">Offer / Recommendation</div>
          <div class="text-right mt-2"></div>
        </div>
      } @else {
        <div>
          <div class="text-2xl font-medium">Offer / Recommendation - {{offerTypeViewHeading}} Type</div>
          <div class="text-right mt-2">{{offerTypeViewTtitle}}</div>
        </div>
      }
      
    </div>
  </div>


  <div *ngIf="!isOffersTypeView" class="flex justify-content-between">
    <div class="flex flex-row gap-3 align-items-center">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>

      <p-floatLabel>
        <p-dropdown class="w-full" id="offersTypeOptions" [options]="offersStatusOptions" [(ngModel)]="filterOffersStatus" (onChange)="this.getOffersTableData($event.value)" optionLabel="label" optionValue="id" placeholder="Select Type"></p-dropdown>
        <label for="creditors">Has Offer</label>
      </p-floatLabel>
         
    </div>

    <div>
      <!-- <remitter-button   
        (click)="onOpenSideBar()" 
        label='Add New'
        icon='plus'
        severity='info'
       >     
      </remitter-button> -->
    </div>
   
</div>
<div *ngIf="!isOffersTypeView" class="mt-4">
    <div 
      *ngIf="!hasTableData && hasClickedSearch"
      style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
            🚫 No records found for {{ creditorCompanyName }}
    </div>
    <p-table 
      *ngIf="hasTableData"
      [value]="filteredOffersConfigs" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true"
    [rows]="10" [rowsPerPageOptions]="[10, 20, 30]" >
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>Creditor Id</th>
                <th>Creditor Name</th>
                <th>Is SIF</th>    
                <th>Settlement Type</th>         
                <th>Action</th>         
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-offers>
            <tr class="text-xs">
                <td>{{ offers.CreditorId }}</td>
                <td>{{ offers.CompanyName }}</td>
                <td>{{ offers.IsSettlementPaymentEnabled === 1 ? 'Yes' : 'No'}}</td>
                 <td>{{ getSettlementTypeText(offers) }}</td>
                <td>
                    <div class="flex align-items-center gap-2">
                      <p-inputSwitch (ngModelChange)="onCreditorStatusChange(offers.CreditorId, $event)" [ngModel]="filterOffersStatus == 1 ? true : false" />
                      <button 
                        pTooltip="View Offers" 
                        tooltipPosition='left' 
                        class="rem-bg-light border-round-md py-2 px-2 cursor-pointer mr-1 border-none" 
                        (click)="onOpenOfferTypeView(offers)"
                      >
                        <i [ngClass]="'text-xs pi pi-bars'"></i>
                      </button>
                      </div>
                </td>       
            </tr>
        </ng-template>
    </p-table>
</div>

<div *ngIf="isOffersTypeView">
  <div class="info-container">
    <div class="row mt-4">
      <div class="label">Creditor Id</div>
      <div class="colon">:</div>
      <div class="value">{{offersViewData.CreditorId}}</div>
    </div>

    <div class="row">
      <div class="label">Creditor Name</div>
      <div class="colon">:</div>
      <div class="value">{{offersViewData.CompanyName}}</div>
    </div>

    <div class="row">
      <div class="label">Is SIF</div>
      <div class="colon">:</div>
      <div class="value">{{offersViewData.IsSettlementPaymentEnabled  === 1 ? 'Yes' : 'No' }}</div>
    </div>
  </div>

  <div class="mt-4">
    <div>
      <p-table [value]="getListOffersRes" [tableStyle]="{ 'min-width': '50rem' }" [scrollable]="true" scrollHeight="400px">

        <ng-template pTemplate="header">
          <tr class="text-xs">
            <th>Order No.</th>
            <th>Type</th>
            <th>Frequency</th>
            <th>Installment</th>    
            <!-- <th>Percentage of Balance (%)</th> 
            <th>Balance Discount Offered (%)</th> -->
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
          <tr class="text-xs">
            <td>{{data.OrderNo}}</td>
            <td>
              {{getTransactionTypeLabel(data.TransectionType)}}
            </td>
            <td>
              {{getFrequencyByTransectionType(data)}}
            </td>
            <td>
              {{getTransactionTypeLabel(data.TransectionType) == 'AdHocPayment' ? '-' : data.NoOfInstallment + ' ('+getNumberOfDays(getFrequencyLabel(data.Frequency),data.NoOfInstallment)+')'}}
            </td>
            <!-- <td>

            </td>
            <td>

            </td> -->
            <td>
                <div class="flex align-items-center gap-2">
                  <icon-button
                    (click)="onOpenListOfferSideBar(
                      offersViewData.CreditorId, 
                      offersViewData.CompanyName,{
                        id: data.OfferId,
                        transectionType: data.TransectionType,
                        frequency: data.Frequency,
                        noOfInstallment: data.NoOfInstallment,
                        offerOrderNo: data.OrderNo,
                        isSif: data.IsSIF
                      })"
                    pTooltip="Edit"
                    tooltipPosition='left'
                    [icon]="'pencil'"
                    [styleClass]="'mr-1'"
                  />
                  <icon-button pTooltip="Delete"
                    (click)="onOfferDelete(data.OfferId)"
                    tooltipPosition='left'
                    [icon]="'trash'"
                    [styleClass]="'mr-1'"
                  />
                  <p-inputSwitch (ngModelChange)="onOfferStatusChange(data.OfferId, $event)" [ngModel]="data.IsActive === true" />
                </div>
            </td> 
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center text-sm py-3">
              No data available. Click "Add Row" to create one.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex justify-content-start align-items-start mt-3">
      <remitter-button   
        (click)="onOpenListOfferSideBar(offersViewData.CreditorId,offersViewData.CompanyName)" 
        label='Add Row'
        icon='plus'
        severity='info'
       >     
      </remitter-button>
    </div>
  </div>
</div>
</div>

<p-sidebar [(visible)]="isListOfferSideBarVisible" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{editedId ? 'Update ' : 'Add New '}} Offers</div>

      <ng-container *ngIf="formSelectedCreditorId && formCreditorCompanyName">
        <div class="flex align-items-center justify-content-between mt-4 gap-2">
          <div>{{formCreditorCompanyName}}</div>
          <div>{{formSelectedCreditorId}}</div>
        </div>   
        <div class="flex align-items-center mt-4 gap-2">
          <p-floatLabel>
            <input type="number" class="w-full" [(ngModel)]="offerOrderNo" pInputText id="offerOrderNo" placeholder="Order Number" />
          </p-floatLabel>
        </div>
        <div class="mt-5">
          <p-floatLabel>
            <p-dropdown class="w-full" id="transactionTypeOptions" (onChange)="onChangeTransactionType()" [(ngModel)]="offerTransactionType" [options]="transactionTypeList" optionLabel="TransactionType" optionValue="Id" placeholder="Select Type"></p-dropdown>
            <label for="creditors">Type</label>
          </p-floatLabel>
        </div>   
        <div *ngIf="isRecurringTypeSelected === 'RecurringPayment'">
          <div class="mt-5">
            <p-floatLabel>
              <p-dropdown class="w-full" id="frequencyListOptions" (onChange)="checkOfferDays()" [(ngModel)]="offerFrequency" [options]="frequencyList" optionLabel="PaymentFrequency" optionValue="Frequency" placeholder="Select Frequency"></p-dropdown>
              <label for="creditors">Frequency</label>
            </p-floatLabel>
          </div>   
          <div class="flex align-items-center mt-4 gap-2">
            <p-floatLabel>
              <input type="number" class="w-full" (ngModelChange)="offerInstallment = $event; checkOfferDays()" [(ngModel)]="offerInstallment" pInputText id="installment" placeholder="Installment" />
            </p-floatLabel>
          </div>
          <div *ngIf="offerInstallment" class="flex align-items-center mt-4 gap-2">
            <p-floatLabel>
              <input type="text" class="w-full" [disabled]="true" [(ngModel)]="offerDays" pInputText id="days" placeholder="Days" />
            </p-floatLabel>
          </div>
        </div> 

        <div *ngIf="isRecurringTypeSelected == 'AdHocPayment'">
          <div class="flex gap-4 mt-4">
            <div class="flex align-items-center">
              <p-radioButton
                name="paymentType"
                value="PayNow"
                [(ngModel)]="paymentType"
                inputId="payNow">
              </p-radioButton>

              <label for="payNow" class="ml-2">Pay Now</label>
            </div>

            <div class="flex align-items-center">
              <p-radioButton
                name="paymentType"
                value="SchedulePayment"
                [(ngModel)]="paymentType"
                inputId="schedulePayment">
              </p-radioButton>

              <label for="schedulePayment" class="ml-2">
                Schedule Payment
              </label>
            </div>
          </div>
        </div>
      
        <div class="flex justify-content-end mt-4">
          <remitter-button
            (click)="onSave()" 
            label='Save'
            icon='send'
          >     
          </remitter-button>
        </div>
      </ng-container>

    </div>
</p-sidebar>